import { createSlice } from "@reduxjs/toolkit"

const initialState = {
    content: "This is a floating window!",
    showWindow: false,
    notesText: "",
    categories: [],
    isMinimized: false,
    tempNotesData: {
        notesName: "Temp Notes",
        // lookupValue: "Temp Notes",
        body: "",
        isActive: true,
        isSelected: false,
    },
    listening: false,
    position: {
        x: Math.round(
            (typeof window !== "undefined" ? window?.innerWidth : 300) / 4
        ),
        y: 100,
    },
    callPosition: {
        x: Math.round(
            (typeof window !== "undefined" ? window?.innerWidth : 300) - 430
        ),
        y: Math.round(
            (typeof window !== "undefined" ? window?.innerHeight : 300) - 320
        ),
    },
}

const floatingWindowSlice = createSlice({
    name: "floatingWindow",
    initialState,
    reducers: {
        updateContent: (state, action) => {
            state.content = action.payload
        },
        setShowWindow: (state, action) => {
            state.showWindow = action.payload
        },
        setNotesText: (state, action) => {
            state.notesText = action.payload
        },
        setCategories: (state, action) => {
            state.categories = action.payload
        },
        setIsMinimized: (state, action) => {
            state.isMinimized = action.payload
        },
        setPosition: (state, action) => {
            state.position = action.payload
        },
        setTempNotesData: (state, action) => {
            state.tempNotesData = action.payload
        },
        setListening: (state, action) => {
            state.listening = action.payload
        },
        setCallPosition: (state, action) => {
            state.callPosition = action.payload
        }
    },
})

export const {
    updateContent,
    setShowWindow,
    setNotesText,
    setCategories,
    setIsMinimized,
    setPosition,
    setTempNotesData,
    setListening,
    setCallPosition
} = floatingWindowSlice.actions
export default floatingWindowSlice.reducer
